import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadProvingsForBookingManagerListQueryVariables = {
  status?: Types.Maybe<Types.Scalars['Int']>
};


export type ReadProvingsForBookingManagerListQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title' | 'dateTo' | 'dateFrom' | 'department'>
    & { responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
      & { authorizedEditors: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id'>
      )>> }
    )> }
  )> }
);

export type ReadProvingsForBookingManagerDateViewQueryVariables = {
  status?: Types.Maybe<Array<Types.Maybe<Types.Scalars['Int']>>>
};


export type ReadProvingsForBookingManagerDateViewQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title' | 'dateTo' | 'dateFrom' | 'department'>
    & { responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
      & { authorizedEditors: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id'>
      )>> }
    )> }
  )> }
);

export type ReadProvingsForAppletQueryVariables = {
  status?: Types.Maybe<Array<Types.Maybe<Types.Scalars['Int']>>>,
  id: Types.Scalars['String']
};


export type ReadProvingsForAppletQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title' | 'dateTo' | 'dateFrom' | 'department'>
    & { responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
      & { authorizedEditors: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id'>
      )>> }
    )>, participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'dateTo' | 'dateFrom' | 'orderId' | 'percentage' | 'trackHotelRequired' | 'temporaryPass' | 'passActivation' | 'permanentDriveAuthorization' | 'singleDriveAuthorization' | 'dvEquipment' | 'partsTransport' | 'driverTraining' | 'nordschleife' | 'nordschleifeBookingStatus' | 'group'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, 'department' | 'upn' | 'roles' | 'extension' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, 'company' | 'department' | 'annotation' | 'qBasic' | 'qTurbo' | 'qSupersport' | 'qNordschleife' | 'qMuLow' | 'qOffroad' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'personType' | 'isUnknown' | 'department' | 'supplier' | 'employee' | 'firstName' | 'surName'>
      )>, flight: Types.Maybe<(
        { __typename?: 'Flight' }
        & Pick<Types.Flight, 'flightType' | 'bookingStatus'>
      )>, accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
        )> }
      )>, trackHotels: Types.Maybe<(
        { __typename?: 'TrackHotels' }
        & { outward: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title'>
          )> }
        )>>, return: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title'>
          )> }
        )>> }
      )>, rentalCar: Types.Maybe<(
        { __typename?: 'RentalCar' }
        & Pick<Types.RentalCar, 'carType' | 'dateTo' | 'dateFrom' | 'bookingStatus'>
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & Pick<Types.Ferry, 'dateFrom' | 'timeFrom' | 'dateTo' | 'timeTo' | 'bookingStatus'>
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title'>
        )> }
      )> }
    )>>, vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'internalNumberUnknown' | 'label' | '_id' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin' | 'group'>
      & { eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, '_id' | 'id' | 'internalLabel' | 'label' | 'licensePlate' | 'vin' | 'type' | 'typeDescription' | 'derivative'>
      )>, transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, 'labelExternal' | '_id' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin' | 'group'>
      & { transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
      )> }
    )>>, resourceRequirements: Types.Maybe<Array<(
      { __typename?: 'ResourceRequirement' }
      & Pick<Types.ResourceRequirement, '_id' | 'resourceRequirementType' | 'amount' | 'dateFrom' | 'dateTo' | 'racewayHours' | 'status'>
      & { testTrack: Types.Maybe<(
        { __typename?: 'TestTrack' }
        & Pick<Types.TestTrack, 'title'>
      )>, orderIdDistribution: Types.Maybe<Array<(
        { __typename?: 'OrderIdDistribution' }
        & Pick<Types.OrderIdDistribution, 'orderId' | 'percentage' | 'annotation'>
      )>> }
    )>>, resourceBookings: Types.Maybe<Array<(
      { __typename?: 'ResourceBooking' }
      & Pick<Types.ResourceBooking, '_id' | 'participantId' | 'dateFrom' | 'dateTo' | 'orderId' | 'status' | 'usageTime'>
      & { resource: (
        { __typename?: 'Resource' }
        & Pick<Types.Resource, '_id' | 'type' | 'category' | 'title' | 'parentId' | 'inactive'>
        & { parent: Types.Maybe<(
          { __typename?: 'Resource' }
          & Pick<Types.Resource, '_id' | 'title'>
        )> }
      ) }
    )>> }
  )>, resourceCategories: Array<(
    { __typename?: 'ResourceCategory' }
    & Pick<Types.ResourceCategory, '_id' | 'types'>
  )>, provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | '_deleted' | 'title'>
    & { authorizedEditors: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id'>
    )>> }
  )>, provingGround: Types.Maybe<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title'>
    & { buildings: Types.Maybe<Array<(
      { __typename?: 'Building' }
      & Pick<Types.Building, '_id' | 'title' | 'type'>
    )>>, garages: Types.Maybe<Array<(
      { __typename?: 'Garage' }
      & Pick<Types.Garage, '_id' | 'title' | 'parentId'>
      & { liftingPlatforms: Array<(
        { __typename?: 'LiftingPlatform' }
        & Pick<Types.LiftingPlatform, '_id' | 'title'>
      )> }
    )>>, offices: Types.Maybe<Array<(
      { __typename?: 'Office' }
      & Pick<Types.Office, '_id' | 'title' | 'parentId'>
      & { workstations: Array<(
        { __typename?: 'Workstation' }
        & Pick<Types.Workstation, '_id' | 'title'>
      )> }
    )>>, testTracks: Types.Maybe<Array<(
      { __typename?: 'TestTrack' }
      & Pick<Types.TestTrack, '_id' | 'title'>
      & { usages: Array<(
        { __typename?: 'TestTrackUsage' }
        & Pick<Types.TestTrackUsage, '_id' | 'title'>
      )> }
    )>>, accessories: Types.Maybe<Array<(
      { __typename?: 'Accessory' }
      & Pick<Types.Accessory, '_id' | 'title' | 'type'>
    )>>, coldcells: Types.Maybe<Array<(
      { __typename?: 'ColdCell' }
      & Pick<Types.ColdCell, '_id' | 'title'>
    )>>, refuelling: Types.Maybe<Array<(
      { __typename?: 'Refuelling' }
      & Pick<Types.Refuelling, '_id' | 'title' | 'type'>
    )>>, fleet: Types.Maybe<Array<(
      { __typename?: 'Fleet' }
      & Pick<Types.Fleet, '_id' | 'title' | 'type' | 'inactive'>
    )>> }
  )> }
);

export const ReadProvingsForBookingManagerListDocument = gql`
    query ReadProvingsForBookingManagerList($status: Int) {
  provings(filter: {status: {EQ: $status}}) {
    _deleted
    id
    _id
    status
    title
    dateTo
    dateFrom
    department
    responsible {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    provingGround {
      _id
      title
      countryCode
      authorizedEditors {
        _id
      }
    }
  }
}
    `;

    export function useReadProvingsForBookingManagerListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsForBookingManagerListQuery, ReadProvingsForBookingManagerListQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsForBookingManagerListQuery, ReadProvingsForBookingManagerListQueryVariables>(ReadProvingsForBookingManagerListDocument, baseOptions);
    };
      export function useReadProvingsForBookingManagerListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsForBookingManagerListQuery, ReadProvingsForBookingManagerListQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsForBookingManagerListQuery, ReadProvingsForBookingManagerListQueryVariables>(ReadProvingsForBookingManagerListDocument, baseOptions);
      };
      
export type ReadProvingsForBookingManagerListQueryHookResult = ReturnType<typeof useReadProvingsForBookingManagerListQuery>;
export type ReadProvingsForBookingManagerListQueryResult = ApolloReactCommon.QueryResult<ReadProvingsForBookingManagerListQuery, ReadProvingsForBookingManagerListQueryVariables>;
export const ReadProvingsForBookingManagerDateViewDocument = gql`
    query ReadProvingsForBookingManagerDateView($status: [Int]) {
  provings(filter: {status: {NIN: $status}}) {
    _deleted
    id
    _id
    status
    title
    dateTo
    dateFrom
    department
    responsible {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    provingGround {
      _id
      title
      countryCode
      authorizedEditors {
        _id
      }
    }
  }
}
    `;

    export function useReadProvingsForBookingManagerDateViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsForBookingManagerDateViewQuery, ReadProvingsForBookingManagerDateViewQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsForBookingManagerDateViewQuery, ReadProvingsForBookingManagerDateViewQueryVariables>(ReadProvingsForBookingManagerDateViewDocument, baseOptions);
    };
      export function useReadProvingsForBookingManagerDateViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsForBookingManagerDateViewQuery, ReadProvingsForBookingManagerDateViewQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsForBookingManagerDateViewQuery, ReadProvingsForBookingManagerDateViewQueryVariables>(ReadProvingsForBookingManagerDateViewDocument, baseOptions);
      };
      
export type ReadProvingsForBookingManagerDateViewQueryHookResult = ReturnType<typeof useReadProvingsForBookingManagerDateViewQuery>;
export type ReadProvingsForBookingManagerDateViewQueryResult = ApolloReactCommon.QueryResult<ReadProvingsForBookingManagerDateViewQuery, ReadProvingsForBookingManagerDateViewQueryVariables>;
export const ReadProvingsForAppletDocument = gql`
    query ReadProvingsForApplet($status: [Int], $id: String!) {
  provings(filter: {status: {NIN: $status}}) {
    _deleted
    id
    _id
    status
    title
    dateTo
    dateFrom
    department
    responsible {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    provingGround {
      _id
      title
      authorizedEditors {
        _id
      }
    }
    participants {
      _id
      dateTo
      dateFrom
      person {
        _id
        type
        name
        firstName
        lastName
        email
        ... on Worker {
          company
          department
          annotation
          qBasic
          qTurbo
          qSupersport
          qNordschleife
          qMuLow
          qOffroad
        }
        ... on User {
          department
          upn
          roles
          extension
        }
      }
      unknownPerson {
        personType
        isUnknown
        department
        supplier
        employee
        firstName
        surName
      }
      orderId
      flight {
        flightType
        bookingStatus
      }
      percentage
      accomodation {
        accomodationType
        accomodation {
          _id
          title
          inactive
        }
        dateFrom
        dateTo
        bookingStatus
      }
      trackHotelRequired
      trackHotels {
        outward {
          dateFrom
          dateTo
          hotel {
            _id
            title
          }
          bookingStatus
        }
        return {
          dateFrom
          dateTo
          hotel {
            _id
            title
          }
          bookingStatus
        }
      }
      rentalCar {
        carType
        dateTo
        dateFrom
        bookingStatus
      }
      temporaryPass
      passActivation
      permanentDriveAuthorization
      singleDriveAuthorization
      dvEquipment
      partsTransport
      driverTraining
      ferry {
        outward {
          _id
          title
        }
        return {
          _id
          title
        }
        dateFrom
        timeFrom
        dateTo
        timeTo
        bookingStatus
      }
      nordschleife
      nordschleifeBookingStatus
      group
    }
    vehicles {
      _id
      type
      unknown
      dateTo
      dateFrom
      orderId
      transport {
        transportType
        bookingStatus
      }
      model
      licensePlate
      licensePlateType
      vin
      ... on InternalVehicle {
        internalNumberUnknown
        eqVehicle {
          _id
          id
          internalLabel
          label
          licensePlate
          vin
          type
          typeDescription
          derivative
        }
        label
      }
      ... on ExternalVehicle {
        labelExternal
      }
      group
    }
    resourceRequirements {
      _id
      resourceRequirementType
      testTrack {
        title
      }
      amount
      dateFrom
      dateTo
      racewayHours
      orderIdDistribution {
        orderId
        percentage
        annotation
      }
      status
    }
    resourceBookings {
      _id
      participantId
      resource {
        _id
        type
        category
        title
        parentId
        inactive
        parent {
          _id
          title
        }
      }
      dateFrom
      dateTo
      orderId
      status
      usageTime
    }
  }
  resourceCategories {
    _id
    types
  }
  provingGrounds(filter: {_deleted: {NEQ: true}}) {
    _id
    _deleted
    title
    authorizedEditors {
      _id
    }
  }
  provingGround(id: $id) {
    _id
    title
    buildings {
      _id
      title
      type
    }
    garages {
      _id
      title
      parentId
      liftingPlatforms {
        _id
        title
      }
    }
    offices {
      _id
      title
      parentId
      workstations {
        _id
        title
      }
    }
    testTracks {
      _id
      title
      usages {
        _id
        title
      }
    }
    accessories {
      _id
      title
      type
    }
    coldcells {
      _id
      title
    }
    refuelling {
      _id
      title
      type
    }
    fleet {
      _id
      title
      type
      inactive
    }
  }
}
    `;

    export function useReadProvingsForAppletQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsForAppletQuery, ReadProvingsForAppletQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsForAppletQuery, ReadProvingsForAppletQueryVariables>(ReadProvingsForAppletDocument, baseOptions);
    };
      export function useReadProvingsForAppletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsForAppletQuery, ReadProvingsForAppletQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsForAppletQuery, ReadProvingsForAppletQueryVariables>(ReadProvingsForAppletDocument, baseOptions);
      };
      
export type ReadProvingsForAppletQueryHookResult = ReturnType<typeof useReadProvingsForAppletQuery>;
export type ReadProvingsForAppletQueryResult = ApolloReactCommon.QueryResult<ReadProvingsForAppletQuery, ReadProvingsForAppletQueryVariables>;